import React from 'react';
import { ARS_MARKET, formatAmount } from '../utils/currency';
type PriceDisplayProps = {
  amount: number;
  className?: string;
  showCode?: boolean;
  strikethrough?: boolean;
};
export function PriceDisplay({
  amount,
  className = '',
  showCode = false,
  strikethrough = false
}: PriceDisplayProps) {
  const formatted = `${ARS_MARKET.symbol}${formatAmount(amount, ARS_MARKET)}`;
  return <span className={`${strikethrough ? 'line-through decoration-2' : ''} ${className}`} data-id="element-140" data-mp="2pszijjhy7qoy">
      {formatted}
      {showCode && <span className="ml-1.5 align-middle font-sans text-[0.5em] font-semibold uppercase tracking-widest opacity-60" data-id="element-141" data-mp="2uq9d1dk72sjn">
          {ARS_MARKET.code}
        </span>}
    </span>;
}